import React, { createContext, useContext, useEffect, useState } from "react";
import { useRecentOrdersContext } from "../RecentOrder/RecentOrdersContext";
import axios from "axios";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { useTokenCallContext } from "../../TokenCall";

// Create the Authentication Context
const QuoteOfferContext = createContext();

export const QuoteOfferProvider = ({ children }) => {
  const { dataFetchSuccess, currentUrl } = useTokenCallContext()
  const validWithOTP = localStorage.getItem('validWithOTP') === 'true'
  const [activePage, setActivePage] = useState('quote'); // Default to 'quote'
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const setPage = (page) => setActivePage(page);

  // useEffect to fetch quotes data on component mount
  
  const fetchQuotes = async (retryCount = 3) => {
    setLoading(true);
    setError(null);
  
    try {
      // Retrieve and parse the sessionStorage data
      const data = JSON.parse(sessionStorage.getItem('userData'));
      if (!data) {
        console.error("Failed to fetch account and contact data from session storage");
        setError('User session data is missing.');
        setLoading(false);
        return;
      }
  
      // Check if contactId is present in the session data
      if (!data.contactId) {
        console.error("No contactId found in userData");
        setError('Contact ID is missing in user data.');
        setLoading(false);
        return;
      }
  
      let attempt = 0;
      while (attempt < retryCount) {
        try {
          // Make API call using contactId from session data
          console.log(`Fetching quotes (Attempt ${attempt + 1})`);
          const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/quote/fetch-quotes`,
            { contactGuid: data.contactId }
          );
  
          // If the response is successful, set the quotes data
          setQuotes(response.data);
          console.log("Fetched recent orders:", response.data);
          setLoading(false);
          return; // Exit the function after successful fetch
        } catch (err) {
          attempt += 1;
          console.error(`Error fetching quotes (Attempt ${attempt}):`, err);
  
          // Retry if the attempt limit hasn't been reached
          if (attempt >= retryCount) {
            setError('Failed to fetch quotes data after multiple attempts');
            setLoading(false);
          } else {
            console.log("Retrying to fetch quotes...");
          }
        }
      }
    } catch (err) {
      console.error('Unexpected error during data parsing or request setup:', err);
      setError('An unexpected error occurred while fetching quotes.');
      setLoading(false);
    }
  };
  
  useEffect(() => {
    if(dataFetchSuccess){
      if(currentUrl === "/home/recent-orders"){
        fetchQuotes();
      }
    }
  }, [dataFetchSuccess, currentUrl]);

  // Quote Product API 

  return (
    <QuoteOfferContext.Provider
      value={{
        fetchQuotes, activePage, setPage, quotes, loading
      }}
    >
      {children}
    </QuoteOfferContext.Provider>
  );
};

// Custom hook to use Authentication Context
export const useQuoteOfferContext = () => {
  const context = useContext(QuoteOfferContext);
  if (context === undefined) {
    throw new Error(
      "useQuoteOfferContext must be used within a QuoteOfferProvider"
    );
  }
  return context;
};